import React from 'react';
import ModalWrapper from "./ModalWrapper";
import {actionsState as projectState} from "../Redux/project";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as modulesState} from "../Redux/modules";
import {sendRedrawSimpleEvent, sendUnselectEvent} from "../Helpers/Events";
import {formatPrice, getStrLang} from "../Helpers/functions";
const ModulesList = ()=>{
    const dispatch = useDispatch();
    const modules = useSelector(store=>store.modules.modules);
    const allModules = useSelector(store=>store.modules.allModules);
    // const price = useSelector(store=>store.modules.price);
    const modulePrice = useSelector(store=>store.modules.modulePrice);

    // console.log('price',price)
    // console.log('modulePrice',modulePrice)

    const deleteModule = (module)=>{
        // console.log('deleteModule',module)
        dispatch(modulesState.remove(module));
        dispatch(modulesState.getPrice());
        sendUnselectEvent(document.querySelector('#plan'));
        sendRedrawSimpleEvent(document.querySelector('#plan'));
        // dispatch(projectState.setModal(''));
    }

    const ModuleItem = ({module,index,_modulePrice})=>{
        const item = allModules.find(m=>module.id == m.ID);
        return (
            <div key={index} className="module-card module-card_one-col _active">
                <div className="card-img"><img src={item.IMAGE} alt=""/></div>
                <div className="card-right">
                    <div className="card-section">
                        <div className="card-name">{item.NAME}</div>
                    </div>
                    <div className="card-btns">
                        <div className="card-price">{(_modulePrice)?formatPrice(_modulePrice):''}&nbsp;</div>
                        <span className="btn btn-delete" onClick={()=>deleteModule(module)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25"><g fill="currentColor"><path d="M18.08,3.08H13.85V2.31A2.32,2.32,0,0,0,11.54,0H8.46A2.32,2.32,0,0,0,6.15,2.31v.77H1.92A1.92,1.92,0,0,0,0,5V7.69a.76.76,0,0,0,.77.77h.42l.66,14a2.32,2.32,0,0,0,2.31,2.2H15.84a2.32,2.32,0,0,0,2.31-2.2l.66-14h.42A.76.76,0,0,0,20,7.69V5a1.92,1.92,0,0,0-1.92-1.92ZM7.69,2.31a.77.77,0,0,1,.77-.77h3.08a.77.77,0,0,1,.77.77v.77H7.69ZM1.54,5a.38.38,0,0,1,.38-.38H18.08a.38.38,0,0,1,.38.38V6.92H1.54ZM16.61,22.34a.77.77,0,0,1-.77.74H4.16a.77.77,0,0,1-.77-.74L2.73,8.46H17.27Z"></path><path d="M10,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,10,21.54Z"></path><path d="M13.85,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.77.77,0,0,0,13.85,21.54Z"></path><path d="M6.15,21.54a.77.77,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,6.15,21.54Z"></path></g></svg>
                        </span>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <ModalWrapper
            title = { getStrLang('c3d_jp0tg') }
            onClose={()=>{dispatch(projectState.setModal(''))}}
        >
            <div className="modal-body">
                <div className={"options-title"}>{ getStrLang('c3d_jp0tg') }</div>
                <div className={'all-modules-body'}>
                    {
                        modules.map((m, index)=>{
                            // console.log('modules.map((m, index)=>{',modules)
                            // console.log('modules.map((m, index)=>{',m)
                            const item = allModules.find(mod=>m.id == mod.ID);
                            // console.log('allModules',allModules)
                            // console.log('item',item)
                            let _modulePrice = modulePrice[m.id];
                            // if (_modulePrice)
                            //     _modulePrice = new Intl.NumberFormat('ru-RU', { maximumSignificantDigits: 3 }).format(_modulePrice);
                            if (item.SECTION !== 433 || window.debug) return <ModuleItem key={index} module={m} mID={index} _modulePrice={_modulePrice}/>
                            else return false
                        })
                    }
                </div>
            </div>
        </ModalWrapper>
    )
}
export default ModulesList;
